import { render, staticRenderFns } from "./SimpleChoiceVariants.vue?vue&type=template&id=eba36e42&"
import script from "./SimpleChoiceVariants.vue?vue&type=script&lang=js&"
export * from "./SimpleChoiceVariants.vue?vue&type=script&lang=js&"
import style0 from "./SimpleChoiceVariants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports